const actionTypeIdentifier = 'D6D21E58-D4CC-4F13-A522-900228F67F77'; //this is a newid

export const getContractDropdownList = `GET-CONTRACT-DROPDOWN-LIST-${actionTypeIdentifier}`;
export const setFinanceContractError = `SET-FINANCE-CONTRACT-ERROR-${actionTypeIdentifier}`;
export const setFinanceContractLoading = `SET-FINANCE-CONTRACT-LOADING-${actionTypeIdentifier}`;
export const getVendorList = `GET-CONTRACT-VENDORS-LIST-${actionTypeIdentifier}`;
export const getServiceList = `GET-CONTRACT-SERVICE-LIST-${actionTypeIdentifier}`;
export const setDefaultState = `SET-DEFAULT-STATE-${actionTypeIdentifier}`;

export const contractModel = {
    contractCode: ""
    , contractName: ""
    , vendorDetailId: 0
    , currency: null
    , contractStatusId: 0
    , serviceTypeId: 0
    , circuitTypeId: 0
    , termLength: ""
    , utilization: 0
    , evergreenStatusId: 0
    , effectiveDate: null
    , expirationDate: null
    , attachments: null
}

export const contractCommitmentModel = {
    termCommitmentVolume: "",
    annualCommitmentVolume: "",
    subCommitment: "",
    escalatingCommitment: "",
    exclusivity: "",
    description: ""
};